import PollBar from './PollBar';

export default PollBar;
